// extracted by mini-css-extract-plugin
module.exports = {"piece":"CBChessPiece_piece__3q7cG","inDrag":"CBChessPiece_inDrag___f655","inactive":"CBChessPiece_inactive__16KUL"};